function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.99718 1.95129C3.99718 2.79058 3.33956 3.46629 2.23843 3.46629C1.19847 3.46629 0.533203 2.79058 0.533203 1.95129C0.533203 1.09065 1.21376 0.436279 2.27666 0.436279C3.33956 0.436279 3.98189 1.09065 3.99718 1.95129ZM0.624964 4.66834H3.89013V14.4483H0.624964V4.66834ZM5.84769 7.79082C5.84769 6.56743 5.80181 5.55031 5.75593 4.66834H8.59288L8.74581 6.03398H8.80699C9.2352 5.39384 10.2981 4.45496 12.0569 4.45496C14.1979 4.45496 15.8191 5.79926 15.8191 8.67279V14.4483H12.5462V9.02843C12.5462 7.76237 12.0798 6.90884 10.8946 6.90884C9.99223 6.90884 9.44931 7.48497 9.21991 8.03976C9.12815 8.24603 9.11286 8.53054 9.11286 8.80082V14.4412H5.84769V7.79082Z",
  fill: "currentColor"
});
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.88a6b443.svg";
export { ForwardRef as ReactComponent };